import cards from '../cards/locales';
import common from '../components/locales/index';
import kemtai from '../integrations/locales';
import mixpanel from '../integrations/locales';
import en from './en.json';
import es from './es.json';
import de from './de.json';
import cs from './cs.json';
import ja from './ja.json';
import sk from './sk.json';
import it from './it.json';
import fr from './fr.json';
import pl from './pl.json';
import pt from './pt.json';
import ptBr from './pt-br.json';
import zhHk from './zh-hk.json';

export default {
  en: {
    ...cards.en,
    ...common.en,
    ...kemtai.en,
    ...mixpanel.en,
    ...en,
  },
  es: {
    ...cards.es,
    ...common.es,
    ...kemtai.es,
    ...mixpanel.es,
    ...es,
  },
  de: {
    ...cards.de,
    ...common.de,
    ...kemtai.de,
    ...mixpanel.de,
    ...de,
  },
  cs: {
    ...cards.cs,
    ...common.cs,
    ...kemtai.cs,
    ...mixpanel.cs,
    ...cs,
  },
  ja: {
    ...cards.ja,
    ...common.ja,
    ...kemtai.ja,
    ...mixpanel.ja,
    ...ja,
  },
  sk: {
    ...cards.sk,
    ...common.sk,
    ...kemtai.sk,
    ...mixpanel.sk,
    ...sk,
  },
  it: {
    ...cards.it,
    ...common.it,
    ...kemtai.it,
    ...mixpanel.it,
    ...it,
  },
  fr: {
    ...cards.fr,
    ...common.fr,
    ...kemtai.fr,
    ...mixpanel.fr,
    ...fr,
  },
  pl: {
    ...cards.pl,
    ...common.pl,
    ...kemtai.pl,
    ...mixpanel.pl,
    ...pl,
  },
  pt: {
    ...cards.pt,
    ...common.pt,
    ...kemtai.pt,
    ...mixpanel.pt,
    ...pt,
  },
  'pt-br': {
    ...cards['pt-br'],
    ...common['pt-br'],
    ...kemtai['pt-br'],
    ...mixpanel['pt-br'],
    ...ptBr,
  },
  'zh-hk': {
    ...cards['zh-hk'],
    ...common['zh-hk'],
    ...kemtai['zh-hk'],
    ...mixpanel['zh-hk'],
    ...zhHk,
  },
};
